<div class="d-flex">
  <user-avatar-component class="mr-2" [user]="{id: comment.lenderUserId, fullName: comment.lenderUserName}"></user-avatar-component>

  <!-- not editing -->
  <div *ngIf="!editing" class="w-100">
    <strong>{{ comment.lenderUserName }}</strong>
    <span class="ml-2">{{ comment.content }}</span>
    <div *ngIf="user && user.id === comment.lenderUserId && !deleting" class="mt-2">
      <a href="javascript:" (click)="editing = true">Edit</a>
      <ls-dropdown>
        <ls-dropdown-toggle>
          <a href="javascript:" class="ml-2">Delete</a>
        </ls-dropdown-toggle>
        <ls-dropdown-menu>
          <div class="p-2">
            <small>Are you sure you want to delete this comment?</small>
            <div class="d-flex mt-2 justify-content-between">
              <a href="javascript:" class="btn-link btn-sm">Cancel</a>
              <button class="btn btn-primary btn-sm" (click)="delete()">Confirm</button>
            </div>
          </div>
        </ls-dropdown-menu>
      </ls-dropdown>
    </div>
  </div>

  <!-- editing -->
  <div *ngIf="editing" class="w-100">
    <borrower-activity-comment-form
      *ngIf="user"
      [user]="user" [activity]="activity" [comment]="comment"
      (cancel)="editing = false"
    ></borrower-activity-comment-form>
  </div>

  <div class="pl-2 text-nowrap">{{ comment.modified | timeago }}</div>
</div>
